'use es6';

import PropTypes from 'prop-types';
import styled from 'styled-components';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { PANTERA } from 'HubStyleTokens/colors';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import UIButton from 'UIComponents/button/UIButton';
import UIIcon from 'UIComponents/icon/UIIcon';
import UIButtonGroup from 'UIComponents/button/UIButtonGroup';
import UIDropdown from 'UIComponents/dropdown/UIDropdown';
import UIList from 'UIComponents/list/UIList';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const TableSelectorButtonGroup = styled(UIButtonGroup).withConfig({
  displayName: "TableFloatyPopoverBody__TableSelectorButtonGroup",
  componentId: "sc-1dlb5kg-0"
})(["& .tableFloatyButton{border-width:1px;border-color:", ";border-radius:0;padding-right:6px;padding-left:6px;}& .leadingButton{border-top-left-radius:3px;}& .trailingButton{border-top-right-radius:3px;padding-top:5px;padding-bottom:5px;}"], PANTERA);
const i18nKey = key => `RichTextLib.table.floaty.${key}`;
const propTypes = {
  className: PropTypes.string,
  dropdownClassName: PropTypes.string,
  onOpenStart: PropTypes.func.isRequired,
  onSelectTable: PropTypes.func.isRequired,
  onCloneTable: PropTypes.func.isRequired,
  onDeleteTable: PropTypes.func.isRequired
};
function TableFloatyPopoverBody(props) {
  const {
    className,
    dropdownClassName,
    onOpenStart,
    onSelectTable,
    onCloneTable,
    onDeleteTable
  } = props;
  return /*#__PURE__*/_jsxs(TableSelectorButtonGroup, {
    className: className,
    children: [/*#__PURE__*/_jsx(UITooltip, {
      placement: "top",
      title: I18n.text(i18nKey('tableSelectorTooltip')),
      children: /*#__PURE__*/_jsxs(UIButton, {
        use: "tertiary",
        size: "xs",
        className: "tableFloatyButton leadingButton",
        onClick: onSelectTable,
        children: [/*#__PURE__*/_jsx(UIIcon, {
          name: "table"
        }), /*#__PURE__*/_jsx(FormattedMessage, {
          message: i18nKey('tableSelectorLabel')
        })]
      })
    }), /*#__PURE__*/_jsx(UIDropdown, {
      "aria-label": I18n.text(i18nKey('dropdownButtonAriaLabel')),
      placement: "bottom right",
      arrowSize: "medium",
      iconName: null,
      buttonUse: "tertiary",
      buttonSize: "sm",
      buttonClassName: "tableFloatyButton trailingButton",
      dropdownClassName: dropdownClassName,
      onOpenStart: onOpenStart,
      children: /*#__PURE__*/_jsxs(UIList, {
        children: [/*#__PURE__*/_jsxs(UIButton, {
          "data-test-id": "copy-table-btn",
          onClick: onCloneTable,
          children: [/*#__PURE__*/_jsx(UIIcon, {
            name: "duplicate"
          }), /*#__PURE__*/_jsx(FormattedMessage, {
            message: i18nKey('cloneTable')
          })]
        }), /*#__PURE__*/_jsxs(UIButton, {
          "data-test-id": "delete-table-btn",
          onClick: onDeleteTable,
          children: [/*#__PURE__*/_jsx(UIIcon, {
            name: "delete"
          }), /*#__PURE__*/_jsx(FormattedMessage, {
            message: i18nKey('deleteTable')
          })]
        })]
      })
    })]
  });
}
TableFloatyPopoverBody.propTypes = propTypes;
export default TableFloatyPopoverBody;